import { useRef, useEffect, useCallback } from 'react';
import { reportError } from '../../lib/sentry';

const AUTO_SAVE_DELAY_MS = 500;

export function useAutoSave(saveFn: () => Promise<void>) {
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const trigger = useCallback(() => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(async () => {
      try {
        await saveFn();
      } catch (err) {
        reportError(err);
      }
    }, AUTO_SAVE_DELAY_MS);
  }, [saveFn]);

  const cancel = useCallback(() => {
    clearTimeout(timerRef.current);
  }, []);

  return { trigger, cancel };
}
